import React from 'react'
import cn from 'classnames'
import Slideshow, {
  Slides,
  useSlideshow,
} from 'js/components/Slideshow/Slideshow'
import Slide from 'js/components/Slideshow/Slide'
import MoreButton from './MoreButton'
import RecipeTeaser from './RecipeTeaser'
import Arrow from 'media/arrow-back-current-color.svg?svgr-webpack'
import { Link } from 'react-router-dom'
import { LatestNutritionArticles_start_featuredRecipes } from '../types/LatestNutritionArticles'
import { NonNullableObject } from 'typings'

function SlideshowNav() {
  const { rotateBackwards, rotateForwards } = useSlideshow()

  return (
    <div className="flex mt-32 lg:mx-32">
      {['backwards', 'forwards'].map((direction) => {
        const fwd = direction === 'forwards'
        return (
          <button
            key={direction}
            onClick={fwd ? rotateForwards : rotateBackwards}
            className={cn(
              'cursor-pointer lg:p-2',
              'bg-Bg rounded-full transition',
              'border-1 border-Border hover:border-grey',
              fwd && 'order-3'
            )}
          >
            <div className="w-32 h-32 flex">
              <Arrow
                className={cn(
                  'm-auto transition text-Type transform scale-75',
                  fwd && 'rotate-180'
                )}
              />
              <span className="sr-only">
                {fwd ? 'Previous recipe' : 'Next recipe'}
              </span>
            </div>
          </button>
        )
      })}
      <MoreButton
        className="mx-auto order-2"
        use={Link}
        to="/nutrition-explained/recipes/"
      >
        See more recipes
      </MoreButton>
    </div>
  )
}

type Props = {
  recipes: NonNullableObject<LatestNutritionArticles_start_featuredRecipes>[]
}

export default function NutritionStartRecipes({ recipes }: Props) {
  return (
    <div className="max-w-480 mx-auto lg:-mx-32">
      <Slideshow>
        <Slides>
          {recipes.map((recipe) => (
            <Slide key={recipe.id}>
              <RecipeTeaser
                {...recipe}
                sizes="(min-width: 420px) 420px, 80vw"
              />
            </Slide>
          ))}
        </Slides>
        <SlideshowNav />
      </Slideshow>
    </div>
  )
}
